import React from "react";
import {API_ROOT, urlParam} from "../../utils";
import {Trans, useTranslation} from "react-i18next";
import Button from "../../components/button";
import './index.css';

function InvitationResponse () {

    const { t } = useTranslation();

    let ownerName = urlParam('ownerName');
    let status = urlParam('status');

    // invited/invitation-response?ownerName=ABCServices&status=NOT_RECOGNISED

    const content = () => {
        switch (status) {
            case 'NOT_RECOGNIZED':
                return (
                    <>
                        <h2>{t('invitationResponseNotRecognizedTitle')}</h2>
                        <p><Trans i18nKey="invitationResponseNotRecognizedText"  values = {{ownerName: ownerName}} /></p>
                    </>
                );
            case 'OWNER_NOT_FOUND':
                return (
                    <>
                        <h2>{t('invitationResponseOwnerNotFoundTitle')}</h2>
                        <p>{t('invitationResponseOwnerNotFoundText')}</p>
                    </>
                );
            case 'LABEL_NOT_FOUND':
                return (
                    <>
                        <h2>{t('invitationResponseLabelNotFoundTitle')}</h2>
                        <p>{t('invitationResponseLabelNotFoundText')}</p>
                    </>
                );
            case 'EXPIRED':
                return (
                    <>
                        <h2>{t('invitationResponseExpiredTitle')}</h2>
                        <p><Trans i18nKey="invitationResponseExpiredText"  values = {{ownerName: ownerName}} /></p>
                    </>
                );
            case 'ALREADY_EXIST':
                return (
                    <>
                        <h2>{t('invitationResponseExpiredTitle')}</h2>
                        <p><Trans i18nKey="invitationResponseExpiredText"  values = {{ownerName}} /></p>
                    </>
                );
            case 'SUCCESS':
                setTimeout(() => {
	                window.location.href = "/";
                }, 5000);
                break;
            default:
                return (
                    <div>
                        Unknown status.
                    </div>
                )
        }
    };

    const handleContact = () => {
        window.location.href = "mailto:support@getsharedcontacts.com";
    };

    return (
        <div className="invitation-response container">
            <img className="mb-3" src={API_ROOT + "/img/scg_logo.png"} alt={t('textGscTitle')}/>
            <h1 className="mb-4">{t('welcomeToApp')}</h1>
            <div className="py-4">
                {content()}
            </div>
            <div>
                <Button onClick={handleContact} className="btn-outline-primary">{t("contactSupportBtn")}</Button>
            </div>
        </div>
    )
}

export default InvitationResponse;
